<template>
    <div :style="{'height' : domHeight +'px' }">
        <div name="org-tree">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="btns" class="simple-row">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="download()">
                    <span>导出excel</span>
                </button>
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="showStaticFieExp()">
                    <span>统计字段说明</span>
                </button>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="true" :rowNoShow="false" :height="tableHeight" :minColWidth="minColWidth" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);

    import statisWorkApi from '../../api/statisWork'
    import retailerApi from '../../api/retailer'

    import  { showStatisFieExplDlg } from './statisDig';

    export default {
        name: 'swb-device-run-com-statis-list',
        desc: '机构设备运行情况',
        props: {
            queryModel: {
                type: Object,
                default: {
                    filterItems: {},
                },
            },
            domHeight: {
                default: 'auto'
            },
            querySortArea: {
                default: null,
            },
            resultColConf: {
                default: null
            }
        },
        data: function () {
            return {
                confKey: 'swb-device-run-com-statis-list',
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                dataList: null,
                loading: false,
                thisComId: null,
                includeSubComs: false,
                retailerShopCom1: null,
                retailerShopCom2: null,
                retailerShopCom3: null,
                retailerShopCom4: null,
                thisComLevel: null,
                comInfo: {},
                treeCollapse: true,
                exportParams: {},
                assetTypeMap: getEnumMap('assetType', 'value2text'),
                //
                tableHeight: 300, //表格高度
                minColWidth: 120,
                currentDate: new Date(),
                lastPageNumber: null,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getComDetail();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="org-tree"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        watch: {
            queryModel: function (newValue, oldValue) {
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getDeviceRunStatisList();
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(this.querySortArea);
//                resultTable.setColConfRef(this.querySortArea);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'deviceCount': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.deviceCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.deviceCount + '</span>';
                        }
                    },
                    'useSum': function (row, colName, colValue, rowIndex, colConf) {
                        // 在用数量
                        if(row.useSum == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.useSum + '</span>';
                        }
                    },
                    'normalCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 正常数量
                        if(row.normalCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.normalCount + '</span>';
                        }
                    },
                    'outageCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 停用数量
                        if(row.outageCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.outageCount + '</span>';
                        }
                    },
                    'notWrntDueCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 保内数量
                        if(row.notWrntDueCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.notWrntDueCount + '</span>';
                        }
                    },
                    'wrntDueCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 保外数量
                        if(row.wrntDueCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.wrntDueCount + '</span>';
                        }
                    },
                    'failedCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 故障中数量
                        if(row.failedCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.failedCount + '</span>';
                        }
                    },
                    'requiredCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 已报修数量
                        if(row.requiredCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.requiredCount + '</span>';
                        }
                    },
                    'reparingCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 维修中数量
                        if(row.reparingCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.reparingCount + '</span>';
                        }
                    },
                    'faultCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 故障次数
                        if(row.faultCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.faultCount + '</span>';
                        }
                    },
                    'faultRate': function (row, colName, colValue, rowIndex, colConf) {
                        // 故障率(%)
                        if(row.deviceCount != null && row.deviceCount > 0) {
                            return '<span>' + ((row.faultCount / row.deviceCount) * 100).toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'failedOutageTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        // 故障停用时间(分)
                        if(row.failedOutageTimeMi != null && row.failedOutageTimeMi > 0) {
                            return '<span>' + row.failedOutageTimeMi.toFixed(2) + '</span>';
                        } else {
                            return '<span>0</span>';
                        }
                    },
                    'fiscalAcctCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 不在账数量
                        if(row.fiscalAcctCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.fiscalAcctCount + '</span>';
                        }
                    },
                    'assetType': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                    },
                });
            },
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                    this.getComDetail();
                }
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                retailerApi.getRetailerCom(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let comInfo = Utils.merge({}, result.data);
                        self.comInfo = comInfo;
                        self.thisComLevel = comInfo.level;
                        self.thisComId = comInfo.id;
                        self.getDeviceRunStatisList();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null,
                    //
                    this.getDeviceRunStatisList();
            },
            getDeviceRunStatisList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                filterItems.comLevel = self.thisComLevel;
                filterItems.comId = self.thisComId;
                filterItems.isMerchant = false;
                filterItems.includeSubComs = self.includeSubComs;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                this.exportParams = postData;
                let loading = MsgBox.loading();
                statisWorkApi.getDeviceRunStatisList(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        let dataList = result.data.rows;
                        self.dataList = dataList;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(dataList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            formatterAvgTimes: function (row, column, cellValue) {
                return parseFloat(cellValue.toFixed(1));
            },
            download: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(this.totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let pages = Math.ceil(this.totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "机构设备运行情况" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '机构设备运行情况-下载 | 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/statis/work/shop/device/run/statis/list/export/do";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let exportParams = this.exportParams;
                let filterItems = exportParams.filterItems;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            //统计字段解释说明
            showStaticFieExp: function () {
                let theme = "设备运行报表";
                showStatisFieExplDlg(theme);
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/statisWork/DeviceRunComStaticList.vue